import { 
  Navigate, 
  useLocation 
} from 'react-router-dom';

import { useAuth } from '../../contextProviders/AuthProvider';
import { useData } from '../../contextProviders/DataProvider';

import Hourglass from './Hourglass';

export default function GodRoute(props: { children: React.ReactNode }) {
  const { children } = props
  const { isGod } = useAuth();
  const { userState } = useData();

  const location = useLocation();

  return (
    (userState.status === 'authenticating_memberships' || 
      userState.status === 'authenticating_user' || 
      userState.status === 'authenticating_profile') ? (
      <Hourglass />
    ) : (
      userState.status === 'ready' ? (
        isGod ? (
          <>{children}</>
        ) : (
          <Navigate
            replace={true}
            to="/loadingerror"
            state={{ from: `${location.pathname}${location.search}` }}
          />
        )
      ) : (
        <Navigate
          replace={true}
          to="/login"
          state={{ from: `${location.pathname}${location.search}` }}
        />
      )
    )
  );
}